import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import validationform from '../../../validation/validationform';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Validation from '../../../validation/confirm-password-validation';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from '../../../services/Notifierservice';
import { SettingsService } from './service/settings.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
} from '@stripe/stripe-js';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { LoginService } from '../../../components/login/service/login.service';
import * as CryptoJS from 'crypto-js';
import intlTelInput from 'intl-tel-input';

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings.component.scss',
})
export class SettingsComponent implements OnInit {
  tabTriangle = '';
  planType = ['Business Plus', 'Business', 'Trial'];
  activePlanData: any = [];
  planId!: number;
  planName!: string;
  showPlans = 'subcriptionDetails';
  purchaseData: any = [];
  usageDataTemp: any = [];
  usageData: any = [];
  profileData: any = [];
  authenticationData: any = [];
  authenticationEvent: any;
  companyLogoData: any = [];
  authentication!: boolean;
  chooseEmail: boolean = true;
  choosePhone: boolean = false;
  choosenValue!: string;
  submitted: boolean = false;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  passwordForm: FormGroup = new FormGroup({
    currentPassword: new FormControl(''),
    newPassword: new FormControl(''),
    confirmPassword: new FormControl(''),
  });
  private readonly notifier: NotifierService;
  profileForm: FormGroup = new FormGroup({});
  fileData: any = [];
  companyLogofileData: any = [];
  getFileEvent: any;
  imageSrc: any;
  companyLogoImageSrc: any;
  showPrfilePic: boolean = false;
  showCompanyLogo: boolean = false;
  @ViewChild('fileUpload') fileUploadEle: any;
  @ViewChild('fileUpload2') fileUploadEle2: any;
  @ViewChild('usageTab') usageTab!: ElementRef;
  myBlob = new Blob();
  blobFile!: File;
  blobUrl: any;
  audioSafeUrl!: SafeUrl;
  companyLogoForm: FormGroup = new FormGroup({});
  getPictureValue: string = '';
  spinner: boolean = false;
  subscriptionForm!: FormGroup;
  userCountEntry: number = 1;
  userCount!: number;
  accessPhotoSelect: boolean = false;
  accessCompanyPhotoSelect: boolean = false;
  currentPlanData!: string;
  selectedCountry!: string;
  zip!: string;
  buyPlan!: string;
  cardStripedToken!: string;
  showSuccessSubscription: boolean = false;
  subscriptionPlanId!: number;
  spinner2: boolean = false;
  cardNumber!: string;
  userDetails: any;
  userDetails_2: any;
  userSubscription: any;
  maximum_file_per_agent!: number;
  selectedAuthMode: string = 'PASSWORD_ONLY';
  authModes = [
    { value: 'PASSWORD_ONLY', label: 'Password only' },
    { value: 'PASSWORD_OTP', label: 'Password + OTP' },
    { value: 'OTP_ONLY', label: 'OTP only' },
  ];
  country_list = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua &amp; Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia &amp; Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote D Ivoire',
    'Croatia',
    'Cruise Ship',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'French West Indies',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyz Republic',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Pierre &amp; Miquelon',
    'Samoa',
    'San Marino',
    'Satellite',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Kitts &amp; Nevis',
    'St Lucia',
    'St Vincent',
    'St. Lucia',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    "Timor L'Este",
    'Togo',
    'Tonga',
    'Trinidad &amp; Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks &amp; Caicos',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (US)',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontSize: '20px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };
  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };
  stripeCardValid: boolean = false;
  initContry: any;
  myOptions: any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  @Output() private readonly emitImageSrc = new EventEmitter();
  @Output() private readonly emitImageSrcData = new EventEmitter();
  @Output() private readonly emitUpdatedDetails = new EventEmitter();
  @ViewChild(StripeCardComponent) card!: StripeCardComponent;
  @ViewChild('intlInput') intlInput!: ElementRef;
  constructor(
    private readonly subscriptionService: SettingsService,
    private readonly fb: FormBuilder,
    private readonly notifierService: NotifierService,
    private readonly sanitizer: DomSanitizer,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stripeService: StripeService,
    private readonly service: LoginService,
    private readonly router: Router,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    let user: any = localStorage.getItem('user');

    try {
      // Format stored by navigateToDashboard: saltHex::ivHex::ciphertext
      const parts = user?.split('::');
      if (!parts || parts.length !== 3) {
        throw new Error('Invalid user data format');
      }

      const [saltHex, ivHex, ciphertext] = parts; // ← correct order

      const salt = CryptoJS.enc.Hex.parse(saltHex);
      const iv = CryptoJS.enc.Hex.parse(ivHex);

      const key = CryptoJS.PBKDF2(this.service.enCryptKey, salt, {
        keySize: 32,
        iterations: 128,
        hasher: CryptoJS.algo.SHA256,
      });
      const decrypted = CryptoJS.AES.decrypt(ciphertext, key, { iv });
      const data = decrypted.toString(CryptoJS.enc.Utf8);

      if (!data) throw new Error('Decryption produced empty result');

      this.userDetails = JSON.parse(data);
      this.userDetails_2 = JSON.parse(data);
      this.userSubscription = this.userDetails?.plan_id;
    } catch (e) {
      console.error('Failed to decrypt user data', e);
      return;
    }

    this.passwordForm = this.fb.group(
      {
        currentPassword: [
          '',
          [
            Validators.required,
            Validators.maxLength(40),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s])\S{8,}$/,
            ),
          ],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.maxLength(40),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s])\S{8,}$/,
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('newPassword', 'confirmPassword')],
      },
    );

    this.profileForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/\S/)]],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      phone: ['', [Validators.required]],
      user_image: [''],
    });

    this.companyLogoForm = this.fb.group({
      title: ['', [Validators.required, Validators.pattern(/\S/)]],
      caption: ['', [Validators.required, Validators.pattern(/\S/)]],
      logo: ['', Validators.required],
    });

    this.subscriptionForm = this.fb.group({
      card_name: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      card_number: [''],
      userscount: [''],
      company_name: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      address1: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9-]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      address2: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9-]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      city: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      state: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/),
        ],
      ],
      country: [null, Validators.required],
    });
    // role_id 1 for admin
    if (this.userDetails?.role_id === 1 || this.userDetails?.role_id === 0) {
      if (this.userSubscription !== 1 && this.userSubscription) {
        this.getActivePlanDetails();
      }
      this.showTriangle('subscription');
    }
    // role_id 2 for supervisor
    if (this.userDetails?.role_id === 2) {
      this.getUsageData();
      this.showTriangle('usage');
    }
    // role_id 9 for user
    if (this.userDetails?.role_id === 9) {
      this.showTriangle('passwordReset');
    }

    if (
      this.userDetails?.role_id === 9 ||
      this.userDetails?.role_id === 1 ||
      this.userDetails?.role_id === 0 ||
      this.userDetails?.role_id === 2
    ) {
      this.accessPhotoSelect = true; // allow photo selection when no existing photo
      this.showPrfilePic = false; // no existing photo to show
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  get fCompany(): { [key: string]: AbstractControl } {
    return this.companyLogoForm.controls;
  }

  get profile(): { [key: string]: AbstractControl } {
    return this.profileForm.controls;
  }

  get fsubscription(): { [key: string]: AbstractControl } {
    return this.subscriptionForm.controls;
  }
  hideShowPassword(): void {
    this.isText = !this.isText;
    this.eyeIcon = this.isText ? 'fa-eye' : 'fa-eye-slash';
    this.type = this.isText ? 'text' : 'password';
  }

  showTriangle(value: string) {
    this.tabTriangle = value;
    this.submitted = false;
    this.fileData = [];
    this.companyLogoData = [];
    this.companyLogoForm.get('logo')?.setValue(null);
    if (this.tabTriangle === 'subscription') {
      this.showPlans = 'subcriptionDetails';
    } else {
      this.showPlans = '';
    }
  }

  getActivePlanDetails() {
    this.spinner = true;
    this.subscriptionService.getSubscriptionPlan().subscribe({
      next: (response: any) => {
        // API now returns an array of subscription records.
        const records: any[] = Array.isArray(response) ? response : [response];

        // Sort a copy of the array to avoid mutating the original.
        const sortedRecords = [...records].sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
        );

        // Prefer the ACTIVE record; fall back to the most recently created one.
        const active =
          records.find((r) => r.status === 'ACTIVE') ?? sortedRecords[0];

        this.activePlanData = active || {};

        this.userCountEntry = this.activePlanData.purchased_user_count || 1;
        this.userCount = this.activePlanData.purchased_user_count || 1;

        this.planId = this.activePlanData.plan_id;
        this.planName = this.activePlanData.plan_name || '-';

        this.spinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  upgradePlans(value: string) {
    this.showPlans = value;
  }

  getPurchaseData() {
    this.spinner = true;
    this.subscriptionService.getPurchase().subscribe({
      next: (response: any) => {
        this.purchaseData = response;
        this.spinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  getUsageData() {
    this.spinner = true;
    this.subscriptionService.getUsage().subscribe({
      next: (response: any) => {
        this.usageDataTemp = response;
        this.usageData = this.usageDataTemp.result;
        this.spinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  chooseCountry(value: any) {
    this.subscriptionForm.controls['country'].setValue(value);
  }

  getProfileData() {
    this.spinner = true;
    const loggedInUser = Number(sessionStorage.getItem('loggedInUser'));
    this.subscriptionService.getProfile(loggedInUser).subscribe({
      next: (response: any) => {
        this.profileData = response;

        this.profileForm.controls['name'].setValue(this.profileData.username);
        this.profileForm.controls['email'].setValue(this.profileData.email);
        this.profileForm.controls['phone'].setValue(
          this.profileData.phone_number,
        );
        this.profileForm?.get('email')?.disable();

        const imageName = this.profileData.profile_image_name;
        if (imageName) {
          this.subscriptionService.loadProfileImage(imageName).subscribe({
            next: (blob: Blob) => {
              const objectUrl = URL.createObjectURL(blob);
              this.imageSrc = objectUrl;
              this.showPrfilePic = true;
              this.accessPhotoSelect = false;
              this.spinner = false;
            },
            error: (error: HttpErrorResponse) => {
              this.showPrfilePic = false;
              this.accessPhotoSelect = true;
              this.spinner = false;
            },
          });
        } else {
          this.showPrfilePic = false;
          this.accessPhotoSelect = true;
          this.spinner = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  getAuthenticationData() {
    this.spinner = true;
    this.subscriptionService.getAuthentication().subscribe({
      next: (response: any) => {
        this.authenticationData = response;

        // Patch auth_mode
        this.selectedAuthMode =
          this.authenticationData.auth_mode || 'PASSWORD_ONLY';

        // Reset OTP channel checkboxes
        this.chooseEmail = false;
        this.choosePhone = false;

        // Patch send_otp_to only when OTP mode is active
        if (
          this.selectedAuthMode === 'PASSWORD_OTP' ||
          this.selectedAuthMode === 'OTP_ONLY'
        ) {
          const sendTo = this.authenticationData.send_otp_to;
          if (sendTo === 'email') {
            this.chooseEmail = true;
            this.choosePhone = false;
          } else if (sendTo === 'mobile') {
            this.chooseEmail = false;
            this.choosePhone = true;
          } else if (sendTo === 'both') {
            this.chooseEmail = true;
            this.choosePhone = true;
          }
        }

        this.spinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  changeAuthentication(value: any) {
    this.authenticationEvent = value;
    this.authentication = !this.authentication;
    if (this.authentication === true) {
      this.chooseEmail = true;
    } else {
      this.chooseEmail = false;
    }
  }

  onAuthModeChange(mode: string) {
    this.selectedAuthMode = mode;
    this.authenticationEvent = mode;
    if (mode === 'PASSWORD_ONLY') {
      this.authentication = false;
      this.chooseEmail = false;
      this.choosePhone = false;
    } else {
      this.authentication = true;
      this.chooseEmail = true;
      this.choosePhone = false;
    }
  }

  chooseEmailFun(value: string) {
    this.authenticationEvent = value;
    this.chooseEmail = !this.chooseEmail;
  }

  choosePhoneFun(value: string) {
    this.authenticationEvent = value;
    this.choosePhone = !this.choosePhone;
  }

  updateAuthentication() {
    if (this.selectedAuthMode !== 'PASSWORD_ONLY') {
      if (!this.chooseEmail && !this.choosePhone) {
        this.notifier.notify('error', 'Select at least one OTP channel');
        return;
      }
    }

    // Build send_otp_to value
    let sendOtpTo = '';
    if (this.selectedAuthMode !== 'PASSWORD_ONLY') {
      if (this.chooseEmail && this.choosePhone) {
        sendOtpTo = 'both';
      } else if (this.chooseEmail) {
        sendOtpTo = 'email';
      } else if (this.choosePhone) {
        sendOtpTo = 'mobile';
      }
    }

    const payload = {
      auth_mode: this.selectedAuthMode,
      send_otp_to: sendOtpTo,
    };

    this.spinner = true;
    this.subscriptionService.updateTwoWayAuthentication(payload).subscribe({
      next: (response: any) => {
        this.notifier.notify('success', response?.['message']);
        this.spinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  async updatePassword(): Promise<void> {
    this.submitted = true;

    if (!this.passwordForm.valid) {
      return;
    }

    const values = this.passwordForm.value;
    const currentPassword = values.currentPassword;
    const newPassword = values.newPassword;

    try {
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const passPhrase = this.makeRandom(16, possible);
      const salt = this.makeRandom(16, possible);
      const enc = new TextEncoder();

      const keyMaterial = await crypto.subtle.importKey(
        'raw',
        enc.encode(passPhrase),
        { name: 'PBKDF2' },
        false,
        ['deriveKey'],
      );

      const aesKey = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: enc.encode(salt),
          iterations: 100_000,
          hash: 'SHA-256',
        },
        keyMaterial,
        { name: 'AES-GCM', length: 256 },
        false,
        ['encrypt'],
      );

      // ── Encrypt current password ──
      const iv1 = crypto.getRandomValues(new Uint8Array(12));
      const cipher1 = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv: iv1 },
        aesKey,
        enc.encode(currentPassword),
      );
      const combined1 = new Uint8Array(iv1.byteLength + cipher1.byteLength);
      combined1.set(iv1, 0);
      combined1.set(new Uint8Array(cipher1), iv1.byteLength);
      const encryptedData1 = btoa(
        Array.from(combined1)
          .map((b) => String.fromCharCode(b))
          .join(''),
      );

      // ── Encrypt new password ──
      const iv2 = crypto.getRandomValues(new Uint8Array(12));
      const cipher2 = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv: iv2 },
        aesKey,
        enc.encode(newPassword),
      );
      const combined2 = new Uint8Array(iv2.byteLength + cipher2.byteLength);
      combined2.set(iv2, 0);
      combined2.set(new Uint8Array(cipher2), iv2.byteLength);
      const encryptedData2 = btoa(
        Array.from(combined2)
          .map((b) => String.fromCharCode(b))
          .join(''),
      );

      const formEncrypt = {
        encrypted_data1: encryptedData1,
        encrypted_data2: encryptedData2,
        salt: salt,
        pass_phrase: passPhrase,
      };

      this.spinner = true;
      this.subscriptionService.updatePassword(formEncrypt).subscribe({
        next: (response: any) => {
          this.submitted = false;
          this.notifier.notify('success', 'Password Updated Successfully !');
          this.spinner = false;
          let userid: any = this.service.userDetails['userid'];
          this.service.logout(userid).subscribe({
            next: (res: any) => {
              this.notifier.notify(
                'default',
                'You are successfully logged out',
              );
              localStorage.clear();
              this.router.navigate(['login']);
            },
            error: (error: HttpErrorResponse) => {},
          });
        },
        error: (error: HttpErrorResponse) => {
          this.spinner = false;
        },
      });
    } catch (error) {
      console.error('Encryption error:', error);
      this.spinner = false;
    }
  }

  onFileChange(event: any, fileTypes: any, value: string) {
    this.getFileEvent = event;

    if (!this.validateFileSelect(event, fileTypes)) {
      this.resetFileInput(value);
      this.notifier.notify(
        'default',
        `Sorry we can't process the File Type. Only accepted files ${fileTypes.join(', ')}`,
      );
      return;
    }

    this.getPictureValue = value;

    // reset shared state once
    this.fileData = [];
    this.companyLogofileData = [];

    const file = event?.target?.files?.[0];
    if (!file) return;

    switch (value) {
      case 'companyLogo':
        this.handleCompanyLogo(file);
        break;

      case 'profile':
        this.handleProfile(file);
        break;
    }
  }

  private resetFileInput(value: string) {
    if (value === 'companyLog') {
      this.fileUploadEle2.nativeElement.value = null;
    }
    if (value === 'profile') {
      this.fileUploadEle.nativeElement.value = null;
    }
  }

  private handleCompanyLogo(file: File) {
    this.companyLogofileData.push(file);
    this.setPreview(file, (result) => (this.companyLogoImageSrc = result));
    this.showCompanyLogo = true;
  }

  private handleProfile(file: File) {
    this.fileData.push(file);
    this.setPreview(file, (result) => (this.imageSrc = result));
    this.showPrfilePic = true;
  }

  private setPreview(
    file: File,
    callback: (result: string | ArrayBuffer | null) => void,
  ) {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result);
    reader.readAsDataURL(file);
  }

  removeProfilepic() {
    if (this.getPictureValue === 'companyLogo') {
      this.companyLogoImageSrc = '';
      this.fileUploadEle2.nativeElement.value = null;
      this.showCompanyLogo = false;
      this.companyLogofileData = [];
      this.accessCompanyPhotoSelect = true;
      this.companyLogoData.logo = '';
    }
    if (this.getPictureValue === 'profile') {
      this.imageSrc = '';
      this.fileUploadEle.nativeElement.value = null;
      this.showPrfilePic = false;
      this.fileData = [];
      this.accessPhotoSelect = true;
      this.profileData.user_image = '';
    }
  }
  deletePic(value: string) {
    this.getPictureValue = value;
    if (value === 'companyLogo') {
      this.fileUploadEle2.nativeElement.value = null;
    } else {
      this.fileUploadEle.nativeElement.value = null;
    }
  }

  updateProfileData() {
    this.submitted = true;

    const formData = new FormData();

    // required fields
    formData.append('id', this.profileData.id);
    formData.append('username', this.profileForm.controls['name'].value);
    formData.append('phone_number', this.profileForm.controls['phone'].value);

    // file handling
    if (this.profileData.user_image && !this.fileData[0]) {
      const file = this.DataURIToBlob(
        this.imageSrc.changingThisBreaksApplicationSecurity,
      );
      formData.append('file', file, 'image.jpg');
    } else if (this.fileData[0]) {
      formData.append('file', this.fileData[0]);
    }

    if (this.profileForm.valid) {
      this.spinner = true;
      this.submitted = false;

      this.subscriptionService.updateProfile(formData).subscribe({
        next: (response: any) => {
          this.notifier.notify('success', 'Profile Updated Successfully.');
          this.subscriptionService.companylogoBS.next({ value: 'userimage' });
          this.spinner = false;
          this.accessPhotoSelect = false;
        },
        error: (error: HttpErrorResponse) => {
          this.spinner = false;
        },
      });
    }
  }

  updateCompanyLogo() {
    this.submitted = true;
    this.submitted = true;

    if (
      this.companyLogoForm.controls['title'].invalid ||
      this.companyLogoForm.controls['caption'].invalid
    ) {
      this.notifier.notify('default', 'Title and Caption are mandatory');
      return;
    }

    if (
      !this.companyLogoForm.controls['logo'].valid &&
      !this.companyLogofileData[0] &&
      !this.showCompanyLogo
    ) {
      this.notifier.notify('default', 'Please select company logo image');
      return;
    }

    if (
      !this.companyLogoForm.controls['logo'].valid &&
      !this.companyLogofileData[0] &&
      !this.showCompanyLogo
    ) {
      this.notifier.notify('default', 'Please select company logo image');
      return;
    }

    const formData = new FormData();
    formData.append('topic', this.companyLogoForm.controls['title'].value);
    formData.append('caption', this.companyLogoForm.controls['caption'].value);

    if (this.companyLogofileData[0]) {
      // new file selected
      formData.append(
        'file',
        this.companyLogofileData[0],
        this.companyLogofileData[0].name || 'logo.png',
      );
    } else if (this.companyLogoData.logo) {
      // no new file picked, reuse existing preview as blob
      const file = this.DataURIToBlob(
        this.companyLogoImageSrc.changingThisBreaksApplicationSecurity,
      );
      formData.append('file', file, 'logo.png');
    }

    this.companyLogoForm.get('logo')?.clearValidators();
    this.companyLogoForm.get('logo')?.updateValueAndValidity();

    this.spinner = true;
    this.subscriptionService.updateCompanyLogo(formData).subscribe({
      next: (response: any) => {
        this.spinner = false;
        this.submitted = false;
        this.accessCompanyPhotoSelect = false;
        setTimeout(() => {
          this.subscriptionService.companylogoBS.next({ value: 'logo' });
        });
        this.notifier.notify('default', 'Company logo updated.');
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  getCompanyLogoData() {
    this.spinner = true;
    this.subscriptionService.getCompanyLogo().subscribe({
      next: (response: any) => {
        this.companyLogoData = response;

        this.companyLogoForm.controls['title'].setValue(
          this.companyLogoData.topic ?? this.companyLogoData.title,
        );
        this.companyLogoForm.controls['caption'].setValue(
          this.companyLogoData.caption,
        );

        const imageUrl = this.companyLogoData.image_url;

        if (imageUrl) {
          this.subscriptionService.loadLogoImage(imageUrl).subscribe({
            next: (blob: Blob) => {
              const objectUrl = URL.createObjectURL(blob);
              this.companyLogoImageSrc = objectUrl;
              this.showCompanyLogo = true;
              this.accessCompanyPhotoSelect = false;
              this.spinner = false;
            },
            error: (error: HttpErrorResponse) => {
              this.showCompanyLogo = false;
              this.accessCompanyPhotoSelect = true;
              this.spinner = false;
            },
          });
        } else {
          this.showCompanyLogo = false;
          this.accessCompanyPhotoSelect = true;
          this.spinner = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  }

  userCountFun(value: any) {
    if (!value) {
      this.userCountEntry = 1;
    }
    if (value < this.userCount) {
      this.notifier.notify(
        'default',
        'User count should be more than previous count !',
      );
    }
  }

  currentPlan(value: string, plans: string, id: number) {
    this.currentPlanData = value;
    this.buyPlan = plans;
    this.subscriptionPlanId = id;
  }

  createToken(): void {
    const name = this.subscriptionForm.get('card_name')?.value;
    if (this.stripeCardValid === true && this.subscriptionForm.valid) {
      this.spinner2 = true;
      this.stripeService
        .createToken(this.card.element, { name })
        .subscribe((result) => {
          if (result.token) {
            // Use the token
            this.cardStripedToken = result.token.id;
            this.showSuccessSubscription = true;
            this.spinner2 = false;
            this.cardNumber = result.token.card?.last4!;
            this.zip = result.token.card?.address_zip!;
          } else if (result.error) {
            // Error creating the token
            this.spinner2 = false;
          }
        });
    } else {
      this.submitted = true;
      validationform.ValidateAllFormFields(this.subscriptionForm);
      this.notifier.notify('default', 'Please fill Mandatory field!');
    }
  }

  onChange(event: any) {
    if (event.complete === true) {
      this.stripeCardValid = event.complete;
    }
    if (event.complete === false) {
      this.stripeCardValid = event.complete;
    }
  }

  goBackSubscriptionFormSection() {
    this.showSuccessSubscription = false;
  }

  subscriptionSubmit() {
    // need to implement
  }

  validateFileSelect(event: any, fileTypes: string[]): boolean {
    const files = Array.from(event?.target?.files ?? []);

    return files.every((file: any) => {
      const extension =
        file?.name?.substring(file?.name?.lastIndexOf('.') + 1) || file?.name;

      return fileTypes.includes(extension);
    });
  }

  phoneNumberInitialLoad() {
    setTimeout(() => {
      this.initContry = intlTelInput(this.intlInput.nativeElement, {
        allowDropdown: true,
        nationalMode: true,
        initialCountry: 'in',
        separateDialCode: false,
      });
    }, 1000);
  }

  get phoneErrors(): Record<string, any> | null {
    return this.profileForm.get('phone')?.errors ?? null;
  }

  get phoneInvalid(): boolean {
    const control = this.profileForm.get('phone');
    return !!((this.submitted || control?.touched) && control?.errors);
  }

  get profileFormControls() {
    return this.profileForm.controls;
  }

  removePasswordSpaces(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\s/g, '');

    if (input.value !== value) {
      input.value = value;
      this.passwordForm.get(controlName)?.setValue(value);
    }
  }
}
